export default __webpack_public_path__ + "static/media/480_dummy2016-goldschmiede01-mobile-de.ddd4729c.png";